export interface IBody {
  logsState: any
  setLogsState: any
  guid: string
  isProductLogSourceEnabled: boolean
  isServerLogs: boolean
}

export interface IFooter {
  handleOnSubmit: () => void
}

export enum Periods {
  CUSTOM = 'CUSTOM',
  TODAY = 'TODAY',
  THREE_DAYS = 'THREE_DAYS',
  WEEK = 'WEEK',
  TWO_WEEKS = 'TWO_WEEKS',
}

export const initialState = {
  period: { label: 'Today', value: Periods.TODAY },
  from: new Date(),
  to: new Date(),
}

export const LOG_SOURCE_DEFAULT = 'Default'

export const initialStateWithLogSources = {
  period: { label: 'Today', value: Periods.TODAY },
  logSource: { label: LOG_SOURCE_DEFAULT, value: null },
  from: new Date(),
  to: new Date(),
}
